export const REQUEST_TIMEOUT = 30000;
export const TIMEOUT_ERROR_MESSAGE = 'Ocurrió un error de conexión, por favor inténtalo de nuevo en 5 minutos cerrando este mensaje y voviendo a dar click en continuar.';
export const TIMEOUT_ERROR_CODE = 900;
export const RETRY_COUNT = 1;
export const DEFAULT_ERROR_MESSAGE = 'Ocurrió un error, por favor inténtalo de nuevo en 5 minutos.';
export const DEFAULT_ERROR_CODE = 999;
export const HTTP_ERROR_RESPONSE = 'HttpErrorResponse';
export const DEFAULT_PING_URL = 'https://sicuentame.com';
export const FAILURE_RESPONSE_MESSAGE = 'failure response';